import { graphql } from '@api/generated/gql';

const refreshUserStatusMutation = graphql(`
  mutation refreshUserStatus {
    refreshUserStatus {
      status {
        activityStatus
        availabilityStatus
      }
      success
    }
  }
`);

export default refreshUserStatusMutation;
